var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _path6, _path7, _path8, _rect4, _g, _rect5, _rect6, _rect7, _g2, _rect8, _rect9, _g3, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationIntro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 831,
    viewBox: "0 0 511 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.347 51.8136H33.7998C22.5357 51.8136 13.4043 61.5126 13.4043 73.4768V282.357C13.4043 294.321 22.5357 304.02 33.7998 304.02H297.347C308.611 304.02 317.743 294.321 317.743 282.357V73.4768C317.743 61.5126 308.611 51.8136 297.347 51.8136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4043 99.8082L317.743 99.8082",
    stroke: "#D9DBE9",
    strokeWidth: 1.20531,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7661 82.1262C40.8762 82.1262 43.3975 79.605 43.3975 76.4949C43.3975 73.3848 40.8762 70.8635 37.7661 70.8635C34.656 70.8635 32.1348 73.3848 32.1348 76.4949C32.1348 79.605 34.656 82.1262 37.7661 82.1262Z",
    fill: "#04C017"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.936 82.1262C58.0461 82.1262 60.5674 79.605 60.5674 76.4949C60.5674 73.3848 58.0461 70.8635 54.936 70.8635C51.8259 70.8635 49.3047 73.3848 49.3047 76.4949C49.3047 79.605 51.8259 82.1262 54.936 82.1262Z",
    fill: "#FFC147"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1157 82.1262C75.2258 82.1262 77.7471 79.605 77.7471 76.4949C77.7471 73.3848 75.2258 70.8635 72.1157 70.8635C69.0056 70.8635 66.4844 73.3848 66.4844 76.4949C66.4844 79.605 69.0056 82.1262 72.1157 82.1262Z",
    fill: "#55BC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95.1133,
    y: 265.055,
    width: 80.3848,
    height: 8.46318,
    rx: 4.23159,
    fill: "#FFC147"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.267578,
    y: 396.965,
    width: 80.3848,
    height: 9.16057,
    rx: 4.58029,
    fill: "#FA951D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 309.623,
    y: 763.494,
    width: 158.481,
    height: 10.9927,
    rx: 5.49634,
    fill: "#1B6600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M399.337 602.067C399.155 601.82 399.006 601.552 398.894 601.267L397.77 598.9C396.8 596.84 395.489 593.793 393.923 590.064C390.756 582.573 386.721 572.085 382.43 560.44C378.14 548.795 374.19 538.307 371.194 530.731C369.73 527.053 368.521 524.04 367.618 521.792L366.665 519.358C366.533 519.077 366.441 518.779 366.393 518.472C366.574 518.719 366.723 518.988 366.835 519.273L367.959 521.639C368.912 523.699 370.24 526.747 371.807 530.475C374.973 537.966 379.008 548.454 383.299 560.099C387.589 571.745 391.539 582.232 394.535 589.809C396 593.486 397.208 596.5 398.094 598.747C398.485 599.717 398.809 600.45 399.064 601.182C399.196 601.462 399.288 601.76 399.337 602.067Z",
    fill: "#0B0A33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M456.373 161.042L447.117 164.175L443.145 152.717C435.847 131.588 412.59 120.368 391.22 127.502C369.849 134.636 358.472 157.807 365.769 178.936L369.741 190.394L360.449 193.543C356.906 194.845 354.028 197.39 352.415 200.65C350.802 203.91 350.576 207.633 351.786 211.046L377.542 285.6C378.076 287.289 378.964 288.859 380.152 290.218C381.34 291.576 382.804 292.694 384.457 293.505C386.11 294.317 387.919 294.805 389.775 294.942C391.632 295.078 393.498 294.86 395.264 294.3L491.187 261.798C494.778 260.499 497.696 257.931 499.328 254.635C500.961 251.339 501.18 247.572 499.94 244.126L474.167 169.572C473.618 167.887 472.717 166.324 471.517 164.977C470.317 163.629 468.842 162.524 467.182 161.728C465.521 160.932 463.708 160.461 461.851 160.343C459.994 160.225 458.131 160.463 456.373 161.042ZM383.257 172.96C381.29 167.466 381.643 161.464 384.243 156.212C386.843 150.959 391.488 146.863 397.205 144.783C400.028 143.868 403.016 143.501 405.992 143.704C408.968 143.907 411.87 144.676 414.525 145.964C417.181 147.253 419.535 149.035 421.447 151.204C423.36 153.374 424.791 155.886 425.657 158.59L429.611 170.048L387.211 184.418L383.257 172.96ZM437.177 239.12L443.756 258.155C443.877 258.536 443.838 258.947 443.647 259.303C443.456 259.658 443.128 259.929 442.731 260.062L433.511 263.177C433.144 263.274 432.752 263.232 432.417 263.06C432.082 262.889 431.83 262.601 431.714 262.258L425.081 243.309C421.424 243.12 417.916 241.877 415.025 239.747C412.134 237.618 409.999 234.702 408.905 231.391C407.342 227.013 407.627 222.233 409.701 218.05C411.775 213.868 415.476 210.607 420.031 208.951C422.28 208.224 424.66 207.932 427.03 208.094C429.4 208.256 431.712 208.869 433.827 209.895C435.942 210.922 437.817 212.341 439.34 214.068C440.864 215.796 442.005 217.796 442.695 219.95C443.852 223.313 443.947 226.923 442.97 230.337C441.994 233.751 439.987 236.821 437.195 239.171L437.177 239.12Z",
    fill: "#FFC147"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M408.074 269.462C408.074 269.462 406.246 269.462 362.165 269.462C318.084 269.462 280.492 269.462 228.067 269.109H211.918L171.724 269C162.164 268.968 152.971 271.107 146.157 274.95C139.344 278.792 135.466 284.025 135.372 289.503L133 621.587C132.979 624.305 133.891 626.998 135.686 629.513C137.481 632.029 140.123 634.317 143.461 636.247C146.799 638.177 150.768 639.712 155.142 640.763C159.515 641.815 164.207 642.362 168.95 642.375L405.323 643C410.069 643.012 414.773 642.489 419.166 641.46C423.559 640.431 427.555 638.916 430.926 637.002C434.297 635.089 436.977 632.813 438.814 630.305C440.65 627.798 441.606 625.108 441.628 622.389L443.999 290.304C444.056 284.811 440.304 279.53 433.567 275.622C426.83 271.714 417.661 269.498 408.074 269.462Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.256,
    y: 586.887,
    width: 131.912,
    height: 39.3905,
    rx: 19.6952,
    fill: "#1B6600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_599_115681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.498,
    y: 380.589,
    width: 174.579,
    height: 34.3136,
    rx: 17.1568,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.956,
    y: 381.047,
    width: 173.663,
    height: 33.3975,
    rx: 16.6987,
    stroke: "#EFF0F7",
    strokeWidth: 0.916057
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202.498,
    y: 365.023,
    width: 48.3333,
    height: 8.46318,
    rx: 4.23159,
    fill: "#B1B3CB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 254.268,
    y: 325,
    width: 80.3848,
    height: 8.46318,
    rx: 4.23159,
    fill: "#7A7D9C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 216.357,
    y: 393.514,
    width: 82.4451,
    height: 8.46318,
    rx: 4.23159,
    fill: "#EFF0F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_599_115681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.498,
    y: 454.838,
    width: 174.579,
    height: 34.3136,
    rx: 17.1568,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.956,
    y: 455.296,
    width: 173.663,
    height: 33.3975,
    rx: 16.6987,
    stroke: "#EFF0F7",
    strokeWidth: 0.916057
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 202.498,
    y: 439.272,
    width: 48.3333,
    height: 8.46318,
    rx: 4.23159,
    fill: "#B1B3CB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 216.357,
    y: 467.763,
    width: 82.4451,
    height: 8.46318,
    rx: 4.23159,
    fill: "#EFF0F7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_599_115681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 531.087,
    width: 174.579,
    height: 34.3136,
    rx: 17.1568,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.458,
    y: 531.545,
    width: 173.663,
    height: 33.3975,
    rx: 16.6987,
    stroke: "#EFF0F7",
    strokeWidth: 0.916057
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 515.522,
    width: 48.3333,
    height: 8.46318,
    rx: 4.23159,
    fill: "#B1B3CB"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 216.357,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 226.25,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 236.141,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 246.029,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 255.924,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 265.812,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 275.699,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 285.592,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 295.482,
    y: 545.011,
    width: 6.46542,
    height: 6.46542,
    rx: 3.23271,
    fill: "#D9DBE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.606 295.634C293.789 295.113 294.792 294.256 295.492 293.169C296.191 292.083 296.555 290.814 296.539 289.522C296.583 288.682 296.456 287.842 296.165 287.053C295.873 286.263 295.425 285.542 294.846 284.931C294.267 284.321 293.569 283.835 292.797 283.503C292.024 283.171 291.191 283 290.35 283C289.509 283 288.677 283.171 287.904 283.503C287.131 283.835 286.434 284.321 285.855 284.931C285.276 285.542 284.827 286.263 284.536 287.053C284.245 287.842 284.117 288.682 284.162 289.522C284.136 290.827 284.497 292.111 285.2 293.211C285.903 294.311 286.916 295.178 288.111 295.702C278.577 297.132 279.003 307.484 279.003 307.484L301.544 307.586C301.544 307.586 302.072 297.047 292.606 295.634Z",
    fill: "#FA951D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M109.645 822.75V808.193L83.5456 808.006L83.3242 830.02L84.9416 830.139C92.1434 830.599 121.58 831.28 126.415 829.781C131.795 828.113 109.645 822.75 109.645 822.75Z",
    fill: "#1B6600"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M173.917 822.75V808.193L147.817 808.006L147.596 829.798L149.213 829.917C156.415 830.377 185.869 831.28 190.687 829.781C196.067 828.113 173.917 822.75 173.917 822.75Z",
    fill: "#1B6600"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.076 390.476C269.395 389.778 267.71 390.118 267.71 390.118C267.879 389.138 267.879 388.136 267.71 387.156C267.403 386.203 265.258 386.39 265.258 386.39C265.159 385.587 265.159 384.775 265.258 383.972C265.275 383.794 265.237 383.615 265.149 383.46C265.06 383.305 264.926 383.18 264.765 383.104C263.75 382.69 262.659 382.493 261.564 382.525C260.253 381.589 265.565 374.149 267.54 371.765C269.515 369.381 269.157 367.526 267.404 367.526C266.195 367.526 259.997 374.676 258.091 377.077C256.184 379.478 251.127 386.151 250.957 380.822C250.787 375.494 248.642 371.476 247.297 370.795C245.952 370.114 244.521 371.714 245.254 373.195C245.897 374.878 246.298 376.643 246.445 378.439C246.63 379.869 246.567 381.321 246.258 382.729C245.694 385.35 244.925 387.923 243.96 390.425H243.823C243.823 390.425 206.674 426.059 203.984 428.596C201.583 430.877 153.3 425.889 143.612 424.867C140.32 424.385 136.996 424.158 133.669 424.186C129.464 424.373 128.715 424.969 124.527 425.02C113.95 425.138 103.397 426.066 92.9616 427.795C88.2365 428.599 83.8227 430.684 80.2019 433.825C76.5811 436.965 73.8923 441.04 72.429 445.604C62.6735 476.079 40.5746 548.216 36.6758 588.736C33.7296 594.079 31.0699 599.574 28.7079 605.2C25.9668 612.657 26.6308 612.912 27.5502 613.082C30.0359 613.542 32.8621 600.16 33.9177 603.395C34.9732 606.63 28.5547 619.348 31.1596 619.722C34.5646 620.199 37.2717 606.102 37.5951 604.978C37.9186 603.855 39.6041 604.212 39.2977 605.268C38.8039 606.766 34.0198 622.651 37.3568 623.161C39.1955 623.434 39.3998 620.08 39.3998 620.08C39.3998 620.08 42.8049 604.876 44.3542 605.183C45.9035 605.489 44.2521 614.462 43.4689 617.458C42.6857 620.454 43.7753 621.97 45.3757 621.238C46.4653 620.727 49.0702 611.618 49.7853 608.656C50.5004 605.693 52.288 597.487 54.6886 602.237C57.0892 606.987 60.7326 609.745 62.2308 609.814C62.5685 609.775 62.8867 609.636 63.1446 609.414C63.4025 609.193 63.5882 608.9 63.678 608.572C63.7677 608.244 63.7573 607.897 63.6481 607.575C63.5388 607.253 63.3358 606.972 63.0651 606.766C61.7764 605.508 60.6704 604.075 59.7792 602.51C58.985 601.291 58.4089 599.942 58.0767 598.526C57.3906 595.702 56.9913 592.815 56.8849 589.911L56.6125 588.208C60.4262 569.327 71.4075 513.91 87.2581 478.514L93.7618 491.896L96.588 501.805L79.2562 544.589L153.18 543.619L142.148 501.158L155.547 456.892C170.035 457.215 207.236 457.76 213.433 454.951C221.231 451.546 261.564 400.606 261.564 400.606C264.193 398.563 266.711 396.381 269.106 394.068C269.106 394.068 271.558 392.008 270.076 390.476Z",
    fill: "#FCD0CA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0046 512.973C78.1498 505.652 89.1652 469.457 89.1652 469.457C89.1652 469.457 94.5793 498.961 93.1492 502.52C91.8337 505.566 90.2795 508.503 88.5012 511.305C76.0046 530.322 77.6391 539.839 77.6391 539.839L153.147 537.541C153.317 526.985 147.068 502.435 145.775 498.519C144.481 494.603 148.788 481.783 148.788 481.783C148.788 481.783 157.301 473.117 156.994 468.656C156.833 464.649 156.337 460.663 155.513 456.739L201.482 458.441L200.034 427.285L134.01 420.679C131.712 427.165 110.924 423.982 110.924 423.982C88.4842 424.731 87.0881 428.851 77.7582 436.104C68.4283 443.357 52.9863 505.601 52.9863 505.601L76.0046 512.973Z",
    fill: "#1B6600"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.648 505.601C119.339 505.835 118.006 505.904 116.681 505.806C114.212 505.806 110.824 505.635 107.095 505.261C103.367 504.886 99.9958 504.359 97.5952 503.882C96.2716 503.711 94.9737 503.38 93.7305 502.894C95.0616 502.895 96.3897 503.02 97.6974 503.269C100.115 503.575 103.469 504.001 107.18 504.376C110.892 504.75 114.263 505.005 116.698 505.176C118.025 505.193 119.347 505.335 120.648 505.601Z",
    fill: "#1B6600"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.817 499.183C124.508 499.824 123.124 500.299 121.697 500.596C114.905 502.381 107.897 503.212 100.875 503.065C99.4222 503.112 97.9692 502.975 96.5508 502.656C97.9848 502.475 99.4302 502.401 100.875 502.435C103.548 502.35 107.226 502.162 111.278 501.686C115.33 501.209 118.939 500.528 121.493 499.983C122.911 499.604 124.357 499.337 125.817 499.183Z",
    fill: "#1B6600"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.221 470.546C151.187 471.844 151.01 473.134 150.693 474.394C150.251 476.76 149.57 479.995 148.702 483.537C147.833 487.078 146.999 490.347 146.25 492.56C145.949 493.827 145.503 495.055 144.922 496.22C145.017 494.926 145.257 493.647 145.637 492.407C146.284 489.751 147.016 486.686 147.833 483.332C148.65 479.978 149.434 476.914 150.081 474.258C150.311 472.979 150.694 471.733 151.221 470.546Z",
    fill: "#1B6600"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8048 508.632C72.8661 508.024 68.9789 507.119 65.1765 505.925C61.2911 505.016 57.4784 503.821 53.7695 502.35C57.7064 502.968 61.5928 503.872 65.3979 505.057C69.2841 505.962 73.0971 507.157 76.8048 508.632Z",
    fill: "#1B6600"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.329 456.364C155.687 456.475 155.031 456.475 154.388 456.364C152.61 456.182 150.864 455.764 149.196 455.121C146.41 454.075 143.875 452.457 141.752 450.372C139.629 448.288 137.966 445.782 136.869 443.016C135.657 439.974 135.139 436.699 135.354 433.431C135.43 430.735 136.236 428.111 137.686 425.838C138.707 424.306 140.23 423.18 141.994 422.654C142.465 422.524 142.952 422.461 143.441 422.467C143.782 422.467 143.952 422.467 143.952 422.467C143.952 422.467 143.237 422.467 142.096 422.926C140.478 423.524 139.106 424.644 138.197 426.11C135.882 429.753 135.235 436.41 137.704 442.625C138.852 445.555 140.651 448.186 142.964 450.32C144.86 452.066 147.043 453.472 149.417 454.474C151.645 455.355 153.963 455.989 156.329 456.364Z",
    fill: "#1B6600"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.019 457.828C195.593 452.607 195.456 447.367 195.61 442.131C195.477 436.899 195.636 431.664 196.087 426.451C196.513 431.666 196.649 436.901 196.495 442.131C196.638 447.368 196.479 452.609 196.019 457.828Z",
    fill: "#1B6600"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.568 422.586C133.756 418.789 134.147 414.499 134.147 414.499C134.147 414.499 143.545 413.46 144.107 403.756C144.669 394.051 144.107 371.663 144.107 371.663L127.082 362.946L108.184 377.809L111.095 426.331L128.427 427.438C129.752 427.475 131.037 426.984 132.001 426.075C132.965 425.165 133.528 423.91 133.568 422.586Z",
    fill: "#FCD0CA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.254 396.077C135.254 396.077 135.254 396.264 135.101 396.486C134.974 396.646 134.81 396.774 134.623 396.857C134.437 396.94 134.232 396.976 134.028 396.963C132.939 396.963 131.883 395.703 131.509 394.238C131.33 393.529 131.33 392.786 131.509 392.076C131.543 391.766 131.655 391.47 131.834 391.215C132.012 390.959 132.251 390.752 132.53 390.612C132.759 390.517 133.016 390.517 133.245 390.612C133.415 390.696 133.552 390.834 133.637 391.004C133.756 391.293 133.637 391.48 133.637 391.463C133.637 391.446 133.637 391.293 133.466 391.123C133.377 391.001 133.247 390.916 133.099 390.885C132.951 390.853 132.797 390.877 132.666 390.953C132.457 391.079 132.284 391.256 132.162 391.467C132.04 391.679 131.973 391.917 131.968 392.161C131.825 392.795 131.825 393.452 131.968 394.085C132.309 395.413 133.228 396.486 134.045 396.588C134.205 396.61 134.368 396.598 134.523 396.554C134.678 396.51 134.823 396.435 134.948 396.333C135.152 396.196 135.22 396.06 135.254 396.077Z",
    fill: "#F9A799"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M149.946 366.419C148.635 361.958 143.885 359.745 139.56 358.519C132.971 356.646 125.855 355.829 119.419 358.196C112.984 360.562 105.254 364.716 105.254 371.816C101.457 371.51 99.2781 374.83 97.7799 378.95C96.822 381.46 96.2481 384.1 96.0774 386.781C95.6007 396.077 92.9958 408.914 86.9688 415.725C83.5637 419.521 78.8477 422.143 76.9068 426.876C75.2043 430.979 76.0896 435.848 74.5062 440.003C73.0931 443.663 69.9775 446.268 67.6961 449.452C65.3718 453.063 64.004 457.207 63.721 461.492C63.4381 465.778 64.2494 470.065 66.0787 473.951C67.9211 477.738 70.5151 481.109 73.7026 483.86C76.8902 486.612 80.6045 488.686 84.6193 489.955C92.5719 492.375 101.052 492.457 109.051 490.193C115.053 488.758 120.653 485.982 125.429 482.072C130.316 478.082 133.672 472.524 134.929 466.341C136.138 459.395 134.197 452.329 132.75 445.417C128.221 423.573 129.515 422.432 135.236 402.155C135.372 401.798 135.44 401.423 135.542 401.066C135.644 400.708 135.695 400.538 135.764 400.265C135.926 399.464 136.012 398.649 136.019 397.831C135.183 398.142 134.276 398.207 133.405 398.02C132.533 397.833 131.733 397.401 131.099 396.775C130.463 396.108 130.019 395.28 129.815 394.381C129.611 393.482 129.655 392.544 129.941 391.668C130.343 390.709 130.941 389.845 131.698 389.133C132.454 388.42 133.352 387.874 134.333 387.531C136.223 386.747 138.249 386.339 140.105 385.47C144.038 383.598 146.762 379.716 148.618 375.647C150.143 372.827 150.614 369.555 149.946 366.419Z",
    fill: "#0B0A33"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6366 539.839L153.144 537.541L186.003 665.81L179.959 812.943H140.034L144.921 668.943L115.722 579.645L120.217 818.647L79.8669 819.243L75.6275 594.593C75.4403 588.345 73.3972 574.265 74.1634 568.067L77.6366 539.839Z",
    fill: "#3E395F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.767 581.466C124.531 581.544 123.29 581.47 122.073 581.245C119.791 580.973 116.676 580.496 113.253 579.815C109.831 579.134 106.767 578.351 104.554 577.721C103.37 577.461 102.226 577.049 101.148 576.495C101.148 576.24 106.699 577.568 113.509 578.947C120.319 580.326 125.801 581.211 125.767 581.466Z",
    fill: "#7A7D9C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.554 804.873C179.554 805.112 170.513 805.316 159.361 805.316C148.21 805.316 139.152 805.112 139.152 804.873C139.152 804.635 148.193 804.43 159.361 804.43C170.53 804.43 179.554 804.618 179.554 804.873Z",
    fill: "#7A7D9C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.86 812.432C119.86 812.688 111.075 812.875 100.247 812.875C89.4185 812.875 80.6504 812.688 80.6504 812.432C80.6504 812.177 89.4355 811.99 100.247 811.99C111.058 811.99 119.86 812.194 119.86 812.432Z",
    fill: "#7A7D9C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M114.654 811.82C114.415 811.82 113.36 759.603 112.287 695.196C111.214 630.789 110.584 578.538 110.806 578.538C111.027 578.538 112.117 630.738 113.172 695.179C114.228 759.62 114.909 811.82 114.654 811.82Z",
    fill: "#7A7D9C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.19 804.873C174.172 804.641 174.172 804.407 174.19 804.175V802.132C174.19 800.293 174.327 797.654 174.429 794.3C174.667 787.49 175.008 777.599 175.433 765.477C176.353 741.096 177.646 707.488 179.06 670.39C179.06 670.032 179.06 669.692 179.06 669.385V669.505C170.121 633.751 162.034 601.301 156.16 577.823L149.35 550.055C148.567 546.803 147.971 544.266 147.546 542.495C147.341 541.661 147.205 541.014 147.086 540.52C147.02 540.299 146.98 540.07 146.967 539.839C147.055 540.054 147.124 540.276 147.171 540.503C147.307 540.98 147.478 541.627 147.716 542.444C148.176 544.147 148.84 546.735 149.691 549.969C151.393 556.541 153.794 566.007 156.79 577.67C162.715 601.131 170.887 633.496 179.945 669.3V669.419C179.945 669.726 179.945 670.083 179.945 670.424C178.43 707.522 177.051 741.113 176.046 765.494C175.518 777.633 175.076 787.456 174.769 794.3C174.599 797.706 174.463 800.293 174.378 802.132C174.378 803 174.275 803.681 174.258 804.175C174.261 804.41 174.238 804.644 174.19 804.873Z",
    fill: "#7A7D9C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M161.165 666.389C158.298 667.332 155.343 667.988 152.346 668.347C148.669 668.977 145.536 669.419 144.123 669.488V669.147C144.583 669.283 144.821 669.368 144.821 669.436C144.821 669.505 144.531 669.436 144.055 669.436H143.033L144.055 669.13C145.383 668.738 148.515 668.091 152.193 667.427C155.142 666.788 158.148 666.44 161.165 666.389Z",
    fill: "#7A7D9C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M160.469 671.275C157.814 671.397 155.152 671.277 152.518 670.918C149.859 670.863 147.21 670.573 144.602 670.049C149.922 669.615 155.278 670.029 160.469 671.275Z",
    fill: "#7A7D9C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.3164 542.546C78.2107 543.695 79.337 544.642 80.6219 545.325C81.9069 546.009 83.3215 546.414 84.7735 546.513C87.8145 546.874 90.8906 546.816 93.9161 546.343C113.41 544.181 134.062 542.189 153.147 537.541C128.444 538.92 102.344 538.46 77.6399 539.839L77.3845 541.951",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M176.295 165.435L135.227 165.435C124.181 165.435 115.227 174.39 115.227 185.435V226.503C115.227 237.548 124.181 246.503 135.227 246.503H176.295C187.341 246.503 196.295 237.548 196.295 226.503V185.435C196.295 174.389 187.341 165.435 176.295 165.435Z",
    fill: "#1B6600"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M135.564 208.139L147.685 221.16L175.965 190.778",
    stroke: "white",
    strokeWidth: 7.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M462.47 480.682H375.688C364.642 480.682 355.688 489.636 355.688 500.682L355.691 587.465C355.691 598.51 364.645 607.464 375.691 607.464H462.47C473.516 607.464 482.47 598.51 482.47 587.464V500.682C482.47 489.636 473.516 480.682 462.47 480.682Z",
    fill: "#04C017"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.674 549.483C422.531 549.483 430.433 541.334 430.433 531.167C430.433 521 422.531 512.85 412.674 512.85C402.816 512.85 394.914 521 394.914 531.167C394.914 541.334 402.816 549.483 412.674 549.483ZM412.672 555.351C398.194 555.351 385.832 557.708 385.832 567.124C385.832 576.538 398.118 578.98 412.672 578.98C427.147 578.98 439.513 576.623 439.513 567.206C439.513 557.789 427.226 555.351 412.672 555.351ZM449.885 538.677H454.19C455.962 538.677 457.407 540.169 457.407 541.999C457.407 543.828 455.962 545.32 454.19 545.32H449.885V549.61C449.885 551.44 448.443 552.932 446.668 552.932C444.895 552.932 443.45 551.44 443.45 549.61V545.32H439.152C437.376 545.32 435.935 543.828 435.935 541.999C435.935 540.169 437.376 538.677 439.152 538.677H443.45V534.391C443.45 532.561 444.895 531.069 446.668 531.069C448.443 531.069 449.885 532.561 449.885 534.391V538.677Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M498.948 348.861H475.54C469.386 348.861 464.396 353.85 464.396 360.004V381.988C464.396 388.143 469.386 393.132 475.54 393.132H498.948C505.103 393.132 510.092 388.143 510.092 381.988V360.004C510.092 353.85 505.103 348.861 498.948 348.861Z",
    fill: "#FA951D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M307.256 0.467407H293.043C289.307 0.467407 286.277 3.49656 286.277 7.23322V20.5811C286.277 24.3178 289.307 27.347 293.043 27.347H307.256C310.992 27.347 314.022 24.3178 314.022 20.5811V7.23322C314.022 3.49656 310.992 0.467407 307.256 0.467407Z",
    fill: "#FFC147"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M272.137 732.964H253.088C248.08 732.964 244.02 737.023 244.02 742.032V759.922C244.02 764.93 248.08 768.99 253.088 768.99H272.137C277.145 768.99 281.205 764.93 281.205 759.922V742.032C281.205 737.023 277.145 732.964 272.137 732.964Z",
    fill: "#04C017"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_599_115681",
    x: 195.17,
    y: 375.092,
    width: 189.235,
    height: 48.9705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66423
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104626 0 0 0 0 0.0970791 0 0 0 0 0.47443 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_115681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_115681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_599_115681",
    x: 195.17,
    y: 449.342,
    width: 189.235,
    height: 48.9705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66423
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104626 0 0 0 0 0.0970791 0 0 0 0 0.47443 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_115681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_115681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_599_115681",
    x: 192.672,
    y: 525.591,
    width: 189.235,
    height: 48.9705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66423
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104626 0 0 0 0 0.0970791 0 0 0 0 0.47443 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_115681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_115681",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIntro);
export default __webpack_public_path__ + "static/media/organization-intro.1a3aa3479a3f70619664a7aea3c47345.svg";
export { ForwardRef as ReactComponent };